module.exports = __webpack_public_path__ + "static/media/ICONE_MAOS.d2114d0b.png";